import React from "react";

let eventIntercept = false
let observer

export function ChipsPopupContainer() {
    if (!observer) {
        observer = new MutationObserver(function (mutationList, observer) {
            for (const mutation of mutationList) {
                if (mutation.type === 'childList') {
                    const container = document.getElementById('chips-popup-container')
                    const hasPopup = container && container.childElementCount > 0

                    if (eventIntercept !== hasPopup) {
                        eventIntercept = hasPopup
                        if (hasPopup) {
                            window.addEventListener('touchmove', handleTouchMove, {passive: false})
                        } else {
                            window.removeEventListener('touchmove', handleTouchMove)
                        }
                    }
                }
            }
        })
 
        setTimeout(() => {
            const container = document.getElementById('chips-popup-container')
            if (container) {
                observer.observe(container, {childList: true})
            }
        }, 100)
    }

    return (
        <div id="chips-popup-container">

        </div>
    )
}

function handleTouchMove(event) {
    event.preventDefault()
}
